module.exports = __webpack_public_path__ + "static/media/betterPlaceNewLogo.7073aa3a.svg";